<template>
  <v-card flat>
    <v-layout row wrap class="pa-3">
      <v-flex class="text-xs-center text-md-left" xs12 md3>
        <div class="subheading grey--text">App Name</div>
        <div class="display-1 text-md-center">
          <router-link class="black--text" :to="{name: 'app', query: {name: app.name}}">
            {{ app.name }}
          </router-link>
        </div>
      </v-flex>
      <v-flex xs12 md10>
        <div class="subheading grey--text text-xs-center">SLOs</div>
        <v-container grid-list-xl fluid>
          <v-layout row wrap justify-center>
            <v-flex xs12 md1 class="text-xs-center" v-for="(slo, idx) of app.rateSlos" :key="idx">
              <v-progress-circular :size="60" :width="5" :value="budgetPct(slo)" :color="budgetColor(slo)">
                {{ budgetPct(slo) }}%
              </v-progress-circular>
              <div class="caption grey--text">{{ slo.name }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-card>
</template>

<script>
export default {
  name: "AppSummary",
  data() {
    return {
      gradient: ["green", "yellow", "orange", "red"]
    };
  },
  props: {
    app: {
      type: Object,
      required: true
    },
    timeLeft: {
      type: Number,
      required: true
    }
  },
  methods: {
    budgetPct(slo) {
      if (slo.currentErrorBudget.totalBudget == 0.0) {
        return 0.0;
      }

      var pct = 100.0 * slo.currentErrorBudget.remainingBudget / slo.currentErrorBudget.totalBudget;
      return pct.toFixed(1);
    },
    budgetColor(slo) {
      if (slo.currentErrorBudget.totalBudget == 0.0) {
        return "grey";
      }

      var pct = 100.0 * slo.currentErrorBudget.remainingBudget / slo.currentErrorBudget.totalBudget;
      if (pct > 75.0) {
        return "success";
      }
      if (pct > 30.0) {
        return "warning";
      }
      return "error";
    }
  }
};
</script>
